$(document).ready(function(){

  // Trigger mobile navigation
  $('#mobile-nav-trigger').click(function(e){
    e.preventDefault();
    $('body').toggleClass('mobile-nav-active');
    console.log("hello");
  });

  // Photo gallery pop-ups
  $('.auction-gallery').each(function(){
    $(this).magnificPopup({
      delegate: 'a',
      type: 'image',
      mainClass: 'mfp-with-zoom',
      zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out',
        opener: function(openerElement) {
          return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
      },
      gallery: {
        enabled: true,
        preload: [1, 2]
      },
      titleSrc: 'title',
      disableOn: 640
    });
  });

  // Contact form functionality
  var form = $('#contact-form');
  var formMessages = $('#contact-form-messages');
  $(form).submit(function(e){
    e.preventDefault();
    var formData = $(form).serialize();
    console.log('form submitted!')
    $.ajax({
      type: 'POST',
      url: $(form).attr('action'),
      data: formData
    })
    .done(function(response){
      console.log('success!');
      $(formMessages).removeClass('error');
      $(formMessages).addClass('success');
      $(formMessages).text(response);
      $('#form-name').val('');
      $('#form-email').val('');
      $('#form-phone').val('');
      $('#form-message').val('');
    })
    .fail(function(data){
      console.log('failed!');
      $(formMessages).removeClass('success');
      $(formMessages).addClass('error');
      if (data.responseText !== '') {
        $(formMessages).text(data.responseText);
      } else {
        $(formMessages).text('Oops! An error occured and your message could not be sent.')
      }
    });

  });

});
